import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { PATH } from "utils/const";

const RestoreCartError = () => {
  const navigate = useNavigate();
  return (
    <div className="restore-cart-error-container container">
      <div className="row">
        <div className="restore-cart-error-text">
          Oops! It looks like Comporium services have already been ordered at this address. If you have any questions, please call&nbsp;
          <a href="tel:8884032667">888-403-2667</a>.
        </div>
        <div className="text-end mt-4">
          <Button onClick={() => navigate(PATH.ADDRESS_SEARCH)}>Return to Address Search</Button>
        </div>
      </div>
    </div>
  );
};

export default RestoreCartError;
